import { render } from "./CallComponent.vue?vue&type=template&id=30c65b46"
import script from "./CallComponent.vue?vue&type=script&lang=js"
export * from "./CallComponent.vue?vue&type=script&lang=js"

import "./CallComponent.vue?vue&type=style&index=0&id=30c65b46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__